import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'TC',
    name: 'Absorbing Wraith',
    id: 'AbsorbingWraith',
    health: 85,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
    fightFiveAdditionalInfo: `
    <p>During setup, swap one of the nemesis turn order cards for the Unleash turn order card.</p>
    <p>SETUP: You must include the most expensive card in your Barracks in your supply.
       Two different players each suffer 2 damage.</p>
    `,
  },
]